import { Input, OnChanges, SimpleChanges, Component, ViewEncapsulation, ChangeDetectionStrategy, ChangeDetectorRef, ElementRef, Optional, SkipSelf } from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { BehaviorSubject } from 'rxjs';
import mixinDisabled from '../../mixins/disabled';
import { PHOENIX_CONTEXTS, PhxContextService } from '../../services/phx-context-service';

const baseInputMixin = mixinDisabled(
  class {
    constructor() {}
  }
);

export type PhxInputStyle = 'default' | 'borderless' | 'underline';

@Component({
  selector: 'input[phx-input], textarea[phx-input]',
  templateUrl: './phx-input.component.html',
  styleUrls: ['./phx-input.component.scss'],
  exportAs: 'phxInput',
  host: {
    class: 'phx-input',
    '[class.phx-input-borderless]': `phxInputStyle === 'borderless'`,
    '[class.phx-input-force-borderless]': `forceBorderless`,
    '[class.phx-input-underline]': `phxInputStyle === 'underline'`,
    '[class.phx-input-default]': `phxInputStyle === 'default'`,
    '[class.phx-input-disabled]': 'disabled',
    '[attr.disabled]': 'disabled || null',
    '[class.phx-filter]': 'phxContext === PHOENIX_CONTEXTS.FILTER',
  },
  inputs: ['disabled'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PhxInputComponent extends baseInputMixin implements OnChanges {
  @Input() public phxInputStyle: PhxInputStyle = 'default';
  public disabled$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(this.disabled);
  public style$: BehaviorSubject<PhxInputStyle> = new BehaviorSubject<PhxInputStyle>(this.phxInputStyle);
  public readonly PHOENIX_CONTEXTS = PHOENIX_CONTEXTS;
  public phxContext: PHOENIX_CONTEXTS;  
  public forceBorderless: boolean = false;

  ngOnChanges(simpleChanges: SimpleChanges): void{
    const { disabled, phxInputStyle } = simpleChanges;
    if (disabled) {
      this.disabled$.next(coerceBooleanProperty(disabled.currentValue));
    }
    if (phxInputStyle) {
      this.style$.next(phxInputStyle.currentValue);
    }
  }

  constructor(
    private cdr: ChangeDetectorRef,
    public elRef: ElementRef,
    @Optional() @SkipSelf() contextService: PhxContextService
    ) {
    super();
    this.phxContext = contextService?.getType();
  }

  public forceBorderlessStyle(): void {
    this.forceBorderless = true;
    this.cdr.markForCheck();
  }

  public focus(): void {
    this.elRef.nativeElement.focus();
  }
}
